
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M52.325 27.04c0-.4-.1-1.6-.7-1.6h-.4c-1.1-6.3-5.8-11-12.5-11.3-2.7.1-4.8.8-7 2.2-3.1-3.3-7.5-5-12.5-4.1-6.6 1.4-10.4 6.9-11.2 13.2h-.3c-.6 0-.8 1.2-.7 2.1 0 1.4.2 2.8.5 4.1 0 .6.1 1.2.4 1.5 1.4 4.5 4.5 8.5 8.8 10.8.3.1.6.3.9.4-.1 1.4-.1 2.9 1.2 3.6 1.2.6 4.2 0 5.4 0H41.025c1.2-.6 1.2-2.1 1.1-3.5.1 0 .1 0 .2-.1 4.6-1.8 7.9-6.3 9.4-11.1.3-.3.4-1 .4-1.6.1-1.6.2-3.2.2-4.6zm-43.9 1.5h42.3c-.1.5-.1 1-.3 1.6h-41.9c0-.5 0-1-.1-1.6zm13.5-9.4c3.9.2 7.6 2.5 8.5 6.3h-2.6c-.6-3-2.6-5.3-6-5.5-3.4.2-5.3 2.5-6 5.5h-2.6c1.1-3.8 4.8-6.1 8.7-6.3zm0 4c1.6.1 3.5.9 4.3 2.3h-8.6c.8-1.4 2.7-2.3 4.3-2.3zm16.8-2c3 .1 5.7 1.7 6.9 4.3h-2.1c-.7-2.1-2.4-3.6-4.8-3.7-1.2.1-2.3.5-3.3 1.3-.1-.3-.2-.7-.3-1 1.2-.5 2.3-.8 3.6-.9zm0 3.7c.8 0 1.5.2 2.1.6h-4.1c.6-.3 1.2-.6 2-.6zm10.9.6h-2.3c-1-4.2-4.1-7.2-8.6-7.4-1.8.1-3.2.5-4.7 1.4-.2-.3-.3-.6-.5-.9 1.6-.8 3.3-1.2 5.2-1.3 5.2.3 9.5 3.3 10.9 8.2zm-15.2-.1v.1h-2.5c-.8-5.2-4.3-9.2-10-9.5-5.7.3-9.2 4.3-10 9.5h-2.5c2.1-13.3 21.8-13.2 25-.1zm6 20.3h-19.8c-1.8 0-2.1 0-2.2-1.1 3.4.8 7.9.1 11.2.1 3.3 0 7.8.7 11.2-.1 0 .6-.1 1-.4 1.1zm-.1-4.1c-3.4.6-7.3 0-10.7 0-3.4 0-7.1.4-10.5 0-4.1-.5-7.5-4.2-9.4-8.2h39.8c-1.8 4-5.2 7.5-9.2 8.2z"}})])
          )
        }
      }
    